import {
    DefaultButton,
    Dialog, DialogFooter,
    DialogType, Stack
} from "@fluentui/react";
import React, { useEffect, useState } from "react";
import CompactColorPicker from "../Inputs/CompactColorPicker";
import NumberField from "../Inputs/NumberField";
import ToggleField from '../Common/ToggleField';
import { IStorefrontSectionEditorModalProps } from "./StorefrontSectionStyleEditorModal";
import Accordion from "../Common/Accordion";


export interface IBoxShadow {
    x?: number;
    y?: number;
    blur?: number;
    spread?: number;
    color?: string;
    inset?: boolean;
}

const parseBoxShadow = (boxShadowString: string): IBoxShadow => {
    if (!boxShadowString) return {};
    // Regex to match: [inset] xpx ypx blurpx spreadpx color
    const regex = /^(inset\s+)?(-?\d+)px\s+(-?\d+)px\s+(\d+)px\s+(\d+)px\s+(.+)$/;
    const match = boxShadowString.match(regex);
    if (match) {
        return {
            inset: !!match[1],
            x: parseInt(match[2], 10),
            y: parseInt(match[3], 10),
            blur: parseInt(match[4], 10),
            spread: parseInt(match[5], 10),
            color: match[6].trim()
        };
    }
    // fallback: try to parse partials
    const parts = boxShadowString.split(/\s+/);
    let inset = false, x = 0, y = 0, blur = 0, spread = 0, color = '#000';
    let idx = 0;
    if (parts[0] === 'inset') {
        inset = true;
        idx = 1;
    }
    if (parts.length - idx >= 5) {
        x = parseInt(parts[idx], 10);
        y = parseInt(parts[idx + 1], 10);
        blur = parseInt(parts[idx + 2], 10);
        spread = parseInt(parts[idx + 3], 10);
        color = parts.slice(idx + 4).join(' ');
    }
    return { inset, x, y, blur, spread, color };
};

const StorefrontSectionBoxShadowEditorModal: React.FC<IStorefrontSectionEditorModalProps> = props => {
/*    // Default values for box-shadow
    const x = props.css?.boxShadowX || 0;
    const y = props.css?.boxShadowY || 0;
    const blur = props.css?.boxShadowBlur || 0;
    const spread = props.css?.boxShadowSpread || 0;
    const color = props.css?.boxShadowColor || '#000';
    const inset = props.css?.boxShadowInset || false;*/
    
    
    const [boxShadow, setBoxShadow] = useState<IBoxShadow>();

    useEffect(() => {
        if (props.css && typeof props.css.boxShadow === 'string') {
            setBoxShadow(parseBoxShadow(props.css.boxShadow));
        }
    }, [props.css]);

    const previewBoxShadow = () => `${boxShadow?.inset ? 'inset ' : ''}${boxShadow?.x ?? 0}px ${boxShadow?.y ?? 0}px ${boxShadow?.blur ?? 0}px ${boxShadow?.spread ?? 0}px ${boxShadow?.color ?? '#000'}`;
    
    
    const getBoxShadowString = (boxShadow: IBoxShadow) => {
        return `${boxShadow?.inset ? 'inset ' : ''}${boxShadow?.x ?? 0}px ${boxShadow?.y ?? 0}px ${boxShadow?.blur ?? 0}px ${boxShadow?.spread ?? 0}px ${boxShadow?.color ?? '#000'}`;
    }
    
    const updateBoxShadow = (boxShadow: IBoxShadow) => {
        setBoxShadow({...boxShadow});
        if(props.onChange) {
            props.onChange('boxShadow', getBoxShadowString(boxShadow));
        }
    }

    // Build box-shadow string for preview

    return (
        <Dialog
            hidden={!props.displayModal}
            onDismiss={props.closer}
            dialogContentProps={{
                type: DialogType.largeHeader,
                title: 'Modify Effects',
            }}
            modalProps={{
                isBlocking: true,
            }}
        >
            {props.css &&
                <Stack tokens={{ childrenGap: 12 }}>
                    <Accordion useChevron={true} title={'Box Shadow'} beginExpanded={true} >
                        <div style={{ width: 200, height: 100, boxShadow: previewBoxShadow(), background: '#fff', marginBottom: 12 }}>
                            <span style={{ padding: 8 }}>Sample</span>
                        </div>
                        <NumberField suffix={'px'} label="Horizontal Offset (X)" value={boxShadow?.x ?? 0} onChange={val => updateBoxShadow({...boxShadow, x: val})} />
                        <NumberField suffix={'px'} label="Vertical Offset (Y)" value={boxShadow?.y ?? 0} onChange={val => updateBoxShadow({...boxShadow, y: val})} />
                        <NumberField suffix={'px'} label="Blur Radius" value={boxShadow?.blur ?? 0} onChange={val => updateBoxShadow({...boxShadow, blur: val})} />
                        <NumberField suffix={'px'} label="Spread Radius" value={boxShadow?.spread ?? 0} onChange={val => updateBoxShadow({...boxShadow, spread: val})} />
                        <CompactColorPicker label="Shadow Color" color={boxShadow?.color ?? '#000'} onChange={val => updateBoxShadow({...boxShadow, color: val})} />
                        <ToggleField inline={true} label="Inset" checked={!!boxShadow?.inset} onChange={(e, val) => updateBoxShadow({...boxShadow, inset: val})}/>
                    </Accordion>
                </Stack>
            }
            <DialogFooter>
                <DefaultButton
                    primary={true}
                    text='Ok'
                    onClick={props.closer}
                />
            </DialogFooter>
        </Dialog>
    );
}
export default StorefrontSectionBoxShadowEditorModal;
